import SectionContent from './section-content';

export default SectionContent;